require('../../widget/sitepage/404')(fox);


// WEBPACK FOOTER //
// ./chunks/404/index.es.js